import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "i18next";

import Home from "./pages/home/home";
import Navbar from "./components/navbar/navbar";
import Footer from "./components/footer/footer";
import Cookies from "./components/cookies/cookies";
import NotFound from "./pages/notfound/notfound";
import Template from "./pages/template/template";
import Kontakt from "./pages/kontakt/kontakt";
import Kapelle from "./pages/kapelle/kapelle";
import Mitglieder from "./pages/mitglieder/mitglieder";
import Beiträge from "./pages/beitraege/beitraege";
import Maintenance from "./pages/maintenance/maintenance";

// Import your translation files for German and Italian
import translationDE from "./translations/de.json";
import translationIT from "./translations/it.json";

const lang = window.location.pathname.substring(1, 3);

i18n.init({
  interpolation: { escapeValue: false },
  lng: lang,
  resources: {
    de: {
      translation: translationDE,
    },
    it: {
      translation: translationIT,
    },
  },
});

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {

  const Layout = () => {
    return (
      <div className="site">
        <Navbar />
        <ScrollToTop />
        <Outlet />
        <Cookies />
        <Footer />
      </div>
    )
  }

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/kapelle",
          element: <Kapelle />,
        },
        {
          path: "/kapelle/mitglieder",
          element: <Mitglieder />,
        },
        {
          path: "/kapelle/vorstand",
          element: <Template />,
        },
        {
          path: "/jugend/jugendkapelle",
          element: <Template />,
        },
        {
          path: "/jugend/blaeserklasse",
          element: <Template />,
        },
        {
          path: "/boehmische",
          element: <Template />,
        },
        {
          path: "/kontakt",
          element: <Kontakt />,
        },
        {
          path: "/oeffentliche-beitraege",
          element: <Beiträge />,
        },
        {
          path: "/datenschutz",
          element: <Template />,
        },
        {
          path: "/impressum",
          element: <Template />,
        },
        {
          path: "*",
          element: <NotFound />,
        }
      ]
    },
    {
      path: "/maintenance",
      element: <Maintenance />,
    }
  ]);

  return (
    <I18nextProvider i18n={i18n}>
      <RouterProvider router={router} />
    </I18nextProvider>
  );
}

export default App;
